<template>
  <div id="nav-button-container">
    <BrazilBackButton
      v-if="prevFn"
      :click-fn="prevFn"
      :text="prevText"
    />
    <SubmitButton
      ref="submitButton"
      :text="submitText"
      :loading="loading"
      :disabled="submitDisabled"
    />
  </div>
</template>
<script>
import BrazilBackButton from './BrazilBackButton.vue';
import SubmitButton from './SubmitButton.vue';

export default {
  components: { BrazilBackButton, SubmitButton },
  props:      {
    loading: {
      type:     Boolean,
      required: false,
      default:  false,
    },
    submitText: {
      type:     String,
      required: false,
      default:  null,
    },
    prevFn: {
      type:     Function,
      required: false,
      default:  null,
    },
    prevText: {
      type:     String,
      required: false,
      default:  null,
    },
    submitDisabled: {
      type:     Boolean,
      required: false,
      default:  false,
    },
  },
  methods: {
    shakeDisableSubmit() {
      this.$refs.submitButton.shakeDisableButton();
    },
  },
};
</script>

<style lang="scss" scoped>
  #nav-button-container {
    justify-content: center;
    text-align: center;
  }

  .nav-button {
    width: 60%;
    margin: 0.5em 0;
  }

  @media (min-width: 769px) {
    #nav-button-container {
      display: block;
      margin: 1em 0;
      text-align: left;
      justify-content: space-between;
    }
    .nav-button {
      padding: 1em 5em;
      margin: 0.5em;
      width: 30%;
      &#back_button {
        margin-left: 0;
      }
    }
  }
</style>
